@if ( !isEmbed ) {
<h1 class="sr-only">{{formDefinition.description|titlecase}}</h1>
}
<formly-form [form]="step.domForm" [fields]="step.fieldDefinitions" [model]="step.dataModel" [options]="step.formlyOptions">
</formly-form>

@if (stepDefinitions.length > 1 ) {
<mat-card-footer>
  <mat-card-actions align='end'>
    @if ( index !== 0) {
    <button mat-flat-button matStepperPrevious type="button" aria-label="Return to previous step"
      color="accent">Back</button>
    }
    @if ( !isLast ) {
    <button mat-flat-button [disabled]='!canMove' matStepperNext type="button" aria-label="Proceed to next step"
      color="accent">Next</button>
    }
    @if (!!isLast && !!buttonText ) {
    <button mat-flat-button [disabled]='!enabled' type="button" [attr.aria-label]="buttonText"
      color="accent">{{buttonText}}</button>
    }
  </mat-card-actions>
</mat-card-footer>
}